<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> tài liệu </span>
    <span class="event">"{{ title }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      title: null,
      dataJson: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_APPROVE:
          action = "Phê duyệt";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_CREATE:
          action = "Tạo mới";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_REJECT:
          action = "Từ chối";
          break;
        default:
          action = "";
          break;
      }
      this.fromActorFullName = this.vbNotificationView.fromUserName || "-";
      this.action = action;
      this.title = this.dataJson.document.documentName;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-document.vue